export enum StorageForm {
  silo = 'Silo',
  manureBag = 'ManureBag',
  well = 'Well',
  headlandDelivery = 'HeadlandDelivery',
}
